import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/assets/videos/mission.mp4")